import { loadHostingInfrastructureASNData } from '../actions/ioc';

export const baseURL =
  process.env.REACT_APP_API_URL === null
    ? 'http://localhost:8080'
    : process.env.REACT_APP_API_URL;

const Manifest = {
  host: `${baseURL}`,
  resources: {
    Version: {
      version: {
        method: 'GET',
        path: '/api/v1/version/',
      },
    },
    Base: {
      api: {
        method: 'GET',
        path: '/api/v1/',
      },
      base_api: {
        method: 'GET',
        path: '/',
      },
    },
    Accounts: {
      validatePassword: {
        method: 'POST',
        path: '/api/v2/accounts/validate-password/',
      },
      validateEmail: {
        method: 'POST',
        path: '/api/v2/accounts/validate-email/',
      },
    },
    Auth: {
      login: {
        method: 'POST',
        path: '/api/v1/auth/login/',
      },
      register: {
        method: 'POST',
        path: '/api/v2/community/register/',
      },
      impersonate: {
        method: 'POST',
        path: '/api/v2/staff/impersonate/',
      },
      // register: {
      //   method: 'POST',
      //   path: '/api/v1/auth/register/',
      // },
      checkToken: {
        method: 'POST',
        path: '/api/v1/auth/check-token/',
      },
      refreshToken: {
        method: 'POST',
        path: '/api/v1/auth/token-refresh/',
      },
      verifyToken: {
        method: 'POST',
        path: '/api/v1/auth/token-verify/',
      },
      resetPassword: {
        method: 'POST',
        path: '/api/v1/auth/reset-password/',
      },
      confirmPasswordReset: {
        method: 'POST',
        path: '/api/v1/auth/reset-password-confirm/',
      },
      confirmCommunityPasswordReset: {
        method: 'POST',
        path: '/api/v2/community/set-password/',
      },
      enable2fa: {
        method: 'POST',
        path: '/api/v1/2fa/enable/authy/',
      },
      remove2fa: {
        method: 'DELETE',
        path: '/api/v1/2fa/remove/',
      },
      loginWith2fa: {
        method: 'POST',
        path: '/api/v1/2fa/login/',
      },
      load2faQR: {
        method: 'GET',
        path: '/api/v1/2fa/enable/authy/qr-code/',
      },
    },
    Subscription: {
      extend: {
        method: 'POST',
        path: '/api/v1/auth/extend-ui-demo-subscription-confirm/',
      },
    },
    User: {
      loadMySubscriptionPlan: {
        method: 'GET',
        path: '/api/v2/subscriptions/regular-users/my-subscription/',
      },
      details: {
        method: 'GET',
        path: '/api/v1/me/',
      },
      updateProfile: {
        method: 'PATCH',
        path: '/api/v1/me/',
      },
      changePassword: {
        method: 'POST',
        path: '/api/v1/me/change-password/',
      },
      uploadPhoto: {
        method: 'POST',
        path: '/api/v1/users/{uuid}/photo/',
      },
      updateOrganization: {
        method: 'PATCH',
        path: '/api/v1/users/me/organisation/',
      },

      // updateIPIndicatorsOrganization: {
      //   method: 'PUT',
      //   path: '//users/me/organisation/{id}/',
      // },
      setCustomIPRangeIndicator: {
        method: 'POST',
        path: '/api/v1/custom-ip-range/',
      },
      // setCustomIPRangeIndicator: {
      //   method: 'GET',
      //   path: '//custom-ip-range/',
      // },
      createCustomGeoIPList: {
        method: 'POST',
        path: '/api/v1/custom-geo-ip/',
      },
      setCustomGeoIP: {
        method: 'PUT',
        path: '/api/v1/custom-geo-ip/{uuid}/',
      },
      loadCustomGeoIPOrganisation: {
        method: 'GET',
        path: '/api/v1/custom-geo-ip/',
      },
      loadCustomGeoIP: {
        method: 'GET',
        path: '/api/v1/custom-geo-ip/{uuid}/',
      },
      loadCustomDomainIndicators: {
        method: 'GET',
        path: '/api/v1/custom-domains/',
      },
      setCustomDomainIndicators: {
        method: 'POST',
        path: '/api/v1/custom-domains/',
      },
      deleteCustomDomainIndicators: {
        method: 'DELETE',
        path: '/api/v1/custom-domains/{uuid}/',
      },
      loadCustomIPRangeIndicators: {
        method: 'GET',
        path: '/api/v1/custom-ip-range/',
      },
      setCustomIPRangeIndicators: {
        method: 'POST',
        path: '/api/v1/custom-ip-range/',
      },
      updateCustomIPRangeIndicators: {
        method: 'PUT',
        path: '/api/v1/custom-ip-range/{uuid}/',
      },
      deleteCustomIPRangeIndicators: {
        method: 'DELETE',
        path: '/api/v1/custom-ip-range/{uuid}/',
      },
      invite: {
        method: 'GET',
        path: '/api/v1/users/{uuid}/invite/',
      },
      activate: {
        method: 'POST',
        path: '/api/v1/users/activation/',
      },
      loadOrganization: {
        method: 'GET',
        path: '/api/v1/users/me/organisation/',
      },
      loadPreferences: {
        method: 'GET',
        path: '/api/v1/users/me/scoringmodel/',
      },
      loadUserFilterProfiles: {
        method: 'GET',
        path: '/api/v1/filter-profile/',
      },
      loadUserFilterProfileDetails: {
        method: 'GET',
        path: '/api/v1/filter-profile/{uuid}/',
      },
      updatePreferences: {
        method: 'PATCH',
        path: '/api/v1/users/me/scoringmodel/',
      },
      loadFilterProfiles: {
        method: 'GET',
        path: '/api/v1/filter-profile/',
      },
      saveFilterProfile: {
        method: 'POST',
        path: '/api/v1/filter-profile/',
      },
      updateFilterProfile: {
        method: 'PUT',
        path: '/api/v1/filter-profile/{uuid}/',
      },
      changeFilterProfileName: {
        method: 'PATCH',
        path: '/api/v1/filter-profile/{uuid}/change-name/',
      },
      changeScopeOfFilterProfile: {
        method: 'PATCH',
        path: '/api/v1/filter-profile/{uuid}/change-scope/',
      },
      deleteFilterProfile: {
        method: 'DELETE',
        path: '/api/v1/filter-profile/{uuid}/',
      },
      list: {
        method: 'GET',
        path: '/api/v1/users/',
      },
      create: {
        method: 'POST',
        path: '/api/v1/users/',
      },
      update: {
        method: 'PUT',
        path: '/api/v1/users/{id}/',
      },
      delete: {
        method: 'DELETE',
        path: '/api/v1/users/{id}/',
      },
      loadUsersInfo: {
        method: 'GET',
        path: '/api/v2/org-admins/users/users-info/',
      },
    },
    DeepScan: {
      deleteSPQLQuery: {
        method: 'DELETE',
        path: '/api/v2/web-scanner/query/{uuid}',
      },
      updateSPQLQuery: {
        method: 'PUT',
        path: '/api/v2/web-scanner/query/{uuid}',
      },
      createSPQLQuery: {
        method: 'POST',
        path: '/api/v2/web-scanner/query',
      },
      getSavedSPQLQueries: {
        method: 'GET',
        path: '/api/v2/web-scanner/query',
      },
      getRecentQueries: {
        method: 'GET',
        path: '/api/v2/web-scanner/recently-executed-queries',
      },
      getQueryExamples: {
        method: 'GET',
        path: '/api/v2/web-scanner/query-example',
      },
      getMetadata: {
        method: 'GET',
        path: '/api/v2/web-scanner/metadata',
      },
      query: {
        method: 'POST',
        path: '/api/v2/web-scanner/data',
      },
    },
    IOC: {
      list: {
        method: 'GET',
        path: '/api/v2/iocs/threat-ranking/',
      },
      pagination: {
        method: 'GET',
        path: '/api/v2/iocs/threat-ranking-count/',
      },
      create: {
        method: 'PUT',
        // path: '/api/v1/all-feeds/{uuid}/add-iocs-json/',
        path: '/api/v1/all-feeds/Temp/',
      },
      applyFilterProfile: {
        method: 'POST',
        path: '/api/v2/iocs/threat-ranking/',
      },
      applyFilterProfileCount: {
        method: 'POST',
        path: '/api/v2/iocs/threat-ranking-count/',
      },
      delete: {
        method: 'DELETE',
        path: '/api/v1/raw-iocs/{uuid}/',
      },
      deleteIOCFromCollection: {
        method: 'DELETE',
        path: '/api/v1/raw-iocs/{uuid}/',
      },
      details: {
        method: 'GET',
        path: '/api/v2/iocs/threat-ranking/{id}/',
      },
      newDetails: {
        method: 'GET',
        //@TODO: for now only retrieves overlap and originator, will be expanded
        path: '/api/v2/sources-report/{feed_uuid}/',
      },
      update: {
        method: 'PUT',
        path: '/api/v1/threat-ranking/{id}/',
      },
      createIOCTag: {
        method: 'POST',
        path: '/api/v2/iocs/threat-ranking/{uuid}/tags/',
      },
      deleteIOCTag: {
        method: 'DELETE',
        path: '/api/v2/iocs/threat-ranking/{iocUUID}/tags/{tagUUID}/',
      },
      toggleFalsePositive: {
        method: 'POST',
        path: '/api/v2/iocs/threat-ranking/{ioc_uuid}/false-positive/',
      },
      toggleTruePositive: {
        method: 'POST',
        path: '/api/v2/iocs/threat-ranking/{ioc_uuid}/true-positive/',
      },
      patch: {
        method: 'PATCH',
        path: '/api/v1/threat-ranking/{id}/',
      },
      export: {
        method: 'POST',
        path: '/api/v2/iocs/export/simple-csv/',
        binary: true,
      },
      //this one below is advanced csv
      exportFull: {
        method: 'POST',
        path: '/api/v2/iocs/export/full-csv/',
        binary: true,
      },
      exportSingleIOC: {
        method: 'GET',
        path: '/api/v2/iocs/export/{uuid}/csv/',
        binary: true,
      },
      exportToSplunk: {
        method: 'GET',
        path: '/api/v1/push-data/splunk/',
        binary: true,
      },
      exportToSTIX: {
        method: 'POST',
        path: '/api/v2/iocs/export/stix/',
        binary: true,
      },
      exportToSTIXLimited: {
        method: 'POST',
        path: '/api/v2/iocs/export/stix-limited/',
        binary: true,
      },
      exportJSON: {
        method: 'POST',
        path: '/api/v2/iocs/export/simple-json/',
        binary: true,
      },
      exportFullJSON: {
        method: 'POST',
        path: '/api/v2/iocs/export/full-json/',
        binary: true,
      },
      exportExploreResultToCSV: {
        method: 'GET',
        path: '/api/v1/merge-api/csv-export/{path}',
        binary: true,
      },
      exportExploreResultToJSON: {
        method: 'GET',
        path: '/api/v1/merge-api/json-export/{path}',
        binary: true,
      },
      exportSpoofingToCSV: {
        method: 'POST',
        path: 'api/v1/explore-recipes/spoofing-recipes/csv-export/',
      },
      exportSpoofingToJSON: {
        method: 'POST',
        path: 'api/v1/explore-recipes/spoofing-recipes/json-export/',
      },
      exportDanglingDNSToCSV: {
        method: 'POST',
        path: 'api/v1/explore-recipes/dangling-dns-record-recipes/csv-export/',
      },
      exportDanglingDNSToJSON: {
        method: 'POST',
        path: 'api/v1/explore-recipes/dangling-dns-record-recipes/json-export/',
      },
      exportHostingInfrastructureASNsToCSV: {
        method: 'POST',
        path: 'api/v1/explore-recipes/hosting-infra-asns-recipes/csv-export/',
      },
      exportHostingInfrastructureASNsToJSON: {
        method: 'POST',
        path: 'api/v1/explore-recipes/hosting-infra-asns-recipes/json-export/',
      },
      exportSubdomainFinderToCSV: {
        method: 'POST',
        path: 'api/v1/explore-recipes/subdomain-finder-recipes/csv-export/',
      },
      exportSubdomainFinderToJSON: {
        method: 'POST',
        path: 'api/v1/explore-recipes/subdomain-finder-recipes/json-export/',
      },
      exportShadowITtoCSV: {
        method: 'POST',
        path: 'api/v1/explore-recipes/shadow-it-recipes/csv-export/',
      },
      exportShadowITtoJSON: {
        method: 'POST',
        path: 'api/v1/explore-recipes/shadow-it-recipes/json-export/',
      },
      mergeApiDomain: {
        method: 'GET',
        path: '/api/v1/merge-api/domain/{domain}/',
      },
      mergeApiIp: {
        method: 'GET',
        path: '/api/v1/merge-api/ipv4/{ip}/',
      },
      mergeApiExplore: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadNameServerAutoFill: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadASNAutoFill: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      mergeApiExplorePost: {
        method: 'POST',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadIOCNotes: {
        method: 'GET',
        path: '/api/v2/iocs/threat-ranking/{iocUUID}/notes/',
      },
      deleteIOCNote: {
        method: 'DELETE',
        path: '/api/v2/iocs/threat-ranking/{iocUUID}/notes/{noteUUID}/',
      },
      createIOCNote: {
        method: 'POST',
        path: '/api/v2/iocs/threat-ranking/{uuid}/notes/',
      },
      updateIOCNote: {
        method: 'PUT',
        path: '/api/v2/iocs/threat-ranking/{iocUUID}/notes/{noteUUID}/',
      },
      mergeApiMerge: {
        method: 'GET',
        path: '/api/v1/merge-api/merge{path}',
      },
      mergeApiMergePost: {
        method: 'POST',
        path: '/api/v1/merge-api/merge{path}',
      },
      loadMergeAPIRiskScores: {
        method: 'POST',
        path: '/api/v1/explore-recipes/fill-risk-scores/',
      },
      loadMergeAPIASNDetails: {
        method: 'POST',
        path: '/api/v1/merge-api/fill-asn-details/',
      },
      mergeApiDomainInfraTags: {
        method: 'GET',
        path:
          '/api/v1/merge-api/explore/domain/infratag/{domain}/?is_voluntary={is_voluntary}',
      },
      loadExploreQueryBuilderSchemas: {
        method: 'GET',
        path: '/api/v1/query-builder/available-queries/',
      },
      saveExploreQueryBuilderSchema: {
        method: 'POST',
        path: '/api/v1/query-builder/',
      },
      deleteExploreQueryBuilderSchema: {
        method: 'DELETE',
        path: '/api/v1/query-builder/{uuid}/',
      },
      changeScopeExploreQueryBuilderSchema: {
        method: 'PATCH',
        path: '/api/v1/query-builder/{uuid}/change-scope/',
      },
      loadExploreQueryBuilderSchema: {
        method: 'GET',
        path: '/api/v1/query-builder/{uuid}/',
      },
      loadAttackSurfaceMapping: {
        method: 'GET',
        path: 'api/v1/explore-recipes/recipes/attack-surface-mapping/',
      },
      loadDigitalThreatManagement: {
        method: 'GET',
        path: 'api/v1/explore-recipes/recipes/digital-threat-management/',
      },
      loadExploreRecipes: {
        method: 'GET',
        path: '/api/v1/explore-recipes/recipes/with-query-builder/',
      },
      loadExploreRecipe: {
        method: 'GET',
        path: '/api/v1/explore-recipes/{path}/',
      },
      updateExploreRecipeHostingInfraIPs: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/hosting-infra-ips-recipes/{uuid}/',
      },
      deleteExploreRecipeHostingInfraIPs: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/hosting-infra-ips-recipes/{uuid}/',
      },
      loadExploreRecipeHostingInfraIPs: {
        method: 'GET',
        path: '/api/v1/explore-recipes/hosting-infra-ips-recipes/{uuid}/',
      },
      saveExploreRecipeHostingInfraIPs: {
        method: 'POST',
        path: '/api/v1/explore-recipes/hosting-infra-ips-recipes/',
      },
      changeScopeExploreRecipeHostingInfraIPs: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/hosting-infra-ips-recipes/{uuid}/change-scope/',
      },
      updateExploreRecipeForwardA: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/forward-a-recipes/{uuid}/',
      },
      deleteExploreRecipeForwardA: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/forward-a-recipes/{uuid}/',
      },
      loadExploreRecipeForwardA: {
        method: 'GET',
        path: '/api/v1/explore-recipes/forward-a-recipes/{uuid}/',
      },
      saveExploreRecipeForwardA: {
        method: 'POST',
        path: '/api/v1/explore-recipes/forward-a-recipes/',
      },
      changeScopeExploreRecipeForwardA: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/forward-a-recipes/{uuid}/change-scope/',
      },
      updateExploreRecipeNameServerChanges: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/ns-changes-recipes/{uuid}/',
      },
      deleteExploreRecipeNameServerChanges: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/ns-changes-recipes/{uuid}/',
      },
      loadExploreRecipeNameServerChanges: {
        method: 'GET',
        path: '/api/v1/explore-recipes/ns-changes-recipes/{uuid}/',
      },
      saveExploreRecipeNameServerChanges: {
        method: 'POST',
        path: '/api/v1/explore-recipes/ns-changes-recipes/',
      },
      changeScopeExploreRecipeNameServerChanges: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/ns-changes-recipes/{uuid}/change-scope/',
      },
      updateExploreRecipeTXT: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/txt-recipes/{uuid}/',
      },
      deleteExploreRecipeTXT: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/txt-recipes/{uuid}/',
      },
      loadExploreRecipeTXT: {
        method: 'GET',
        path: '/api/v1/explore-recipes/txt-recipes/{uuid}/',
      },
      saveExploreRecipeTXT: {
        method: 'POST',
        path: '/api/v1/explore-recipes/txt-recipes/',
      },
      changeScopeExploreRecipeTXT: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/txt-recipes/{uuid}/change-scope/',
      },
      deleteExploreRecipeIPDiversity: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/ip-diversity-recipes/{uuid}/',
      },
      loadExploreRecipeIPDiversity: {
        method: 'GET',
        path: '/api/v1/explore-recipes/ip-diversity-recipes/{uuid}/',
      },
      saveExploreRecipeIPDiversity: {
        method: 'POST',
        path: '/api/v1/explore-recipes/ip-diversity-recipes/',
      },
      updateExploreRecipeIPDiversity: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/ip-diversity-recipes/{uuid}/',
      },
      changeScopeExploreRecipeIPDiversity: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/ip-diversity-recipes/{uuid}/change-scope/',
      },
      deleteExploreRecipeLatestDNSRecords: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/latest-dns-record-recipes/{uuid}/',
      },
      loadExploreRecipeLatestDNSRecords: {
        method: 'GET',
        path: '/api/v1/explore-recipes/latest-dns-record-recipes/{uuid}/',
      },
      saveExploreRecipeLatestDNSRecords: {
        method: 'POST',
        path: '/api/v1/explore-recipes/latest-dns-record-recipes/',
      },
      updateExploreRecipeLatestDNSRecords: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/latest-dns-record-recipes/{uuid}/',
      },
      changeScopeExploreRecipeLatestDNSRecords: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/latest-dns-record-recipes/{uuid}/change-scope/',
      },

      loadHostingInfrastructureASNData: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },

      deleteExploreRecipeHostingInfrastructureASNs: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/hosting-infra-asns-recipes/{uuid}/',
      },
      loadExploreRecipeHostingInfrastructureASNs: {
        method: 'GET',
        path: '/api/v1/explore-recipes/hosting-infra-asns-recipes/{uuid}/',
      },
      saveExploreRecipeHostingInfrastructureASNs: {
        method: 'POST',
        path: '/api/v1/explore-recipes/hosting-infra-asns-recipes/',
      },
      updateExploreRecipeHostingInfrastructureASNs: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/hosting-infra-asns-recipes/{uuid}/',
      },
      changeScopeExploreRecipeHostingInfrastructureASNs: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/hosting-infra-asns-recipes/{uuid}/change-scope/',
      },

      loadDanglingDNSRecordsCountData: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      deleteExploreRecipeDanglingDNSRecordsCount: {
        method: 'DELETE',
        path:
          '/api/v1/explore-recipes/dangling-dns-records-count-recipes/{uuid}/',
      },
      loadExploreRecipeDanglingDNSRecordsCount: {
        method: 'GET',
        path:
          '/api/v1/explore-recipes/dangling-dns-records-count-recipes/{uuid}/',
      },
      saveExploreRecipeDanglingDNSRecordsCount: {
        method: 'POST',
        path: '/api/v1/explore-recipes/dangling-dns-records-count-recipes/',
      },
      updateExploreRecipeDanglingDNSRecordsCount: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/dangling-dns-records-count-recipes/{uuid}/',
      },
      changeScopeExploreRecipeDanglingDNSRecordsCount: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/dangling-dns-records-count-recipes/{uuid}/change-scope/',
      },

      loadDanglingDNSProtectionData: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      deleteExploreRecipeDanglingDNSProtection: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/dangling-dns-record-recipes/{uuid}/',
      },
      loadExploreRecipeDanglingDNSProtection: {
        method: 'GET',
        path: '/api/v1/explore-recipes/dangling-dns-record-recipes/{uuid}/',
      },
      saveExploreRecipeDanglingDNSProtection: {
        method: 'POST',
        path: '/api/v1/explore-recipes/dangling-dns-record-recipes/',
      },
      updateExploreRecipeDanglingDNSProtection: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/dangling-dns-record-recipes/{uuid}/',
      },
      changeScopeExploreRecipeDanglingDNSProtection: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/dangling-dns-record-recipes/{uuid}/change-scope/',
      },

      deleteExploreRecipeSubdomainFinder: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/subdomain-finder-recipes/{uuid}/',
      },
      loadExploreRecipeSubdomainFinder: {
        method: 'GET',
        path: '/api/v1/explore-recipes/subdomain-finder-recipes/{uuid}/',
      },
      saveExploreRecipeSubdomainFinder: {
        method: 'POST',
        path: '/api/v1/explore-recipes/subdomain-finder-recipes/',
      },
      updateExploreRecipeSubdomainFinder: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/subdomain-finder-recipes/{uuid}/',
      },
      changeScopeExploreRecipeSubdomainFinder: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/subdomain-finder-recipes/{uuid}/change-scope/',
      },

      deleteExploreRecipeShadowIT: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/shadow-it-recipes/{uuid}/',
      },
      loadExploreRecipeShadowIT: {
        method: 'GET',
        path: '/api/v1/explore-recipes/shadow-it-recipes/{uuid}/',
      },
      saveExploreRecipeShadowIT: {
        method: 'POST',
        path: '/api/v1/explore-recipes/shadow-it-recipes/',
      },
      updateExploreRecipeShadowIT: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/shadow-it-recipes/{uuid}/',
      },
      changeScopeExploreRecipeShadowIT: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/shadow-it-recipes/{uuid}/change-scope/',
      },

      deleteExploreRecipeReverseA: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/reverse-a-recipes/{uuid}/',
      },
      loadExploreRecipeReverseA: {
        method: 'GET',
        path: '/api/v1/explore-recipes/reverse-a-recipes/{uuid}/',
      },
      saveExploreRecipeReverseA: {
        method: 'POST',
        path: '/api/v1/explore-recipes/reverse-a-recipes/',
      },
      updateExploreRecipeReverseA: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/reverse-a-recipes/{uuid}/',
      },
      changeScopeExploreRecipeReverseA: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/reverse-a-recipes/{uuid}/change-scope/',
      },
      deleteExploreRecipeDomainsOnServer: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/domain-on-a-server-recipes/{uuid}/',
      },
      loadExploreRecipeDomainsOnServer: {
        method: 'GET',
        path: '/api/v1/explore-recipes/domain-on-a-server-recipes/{uuid}/',
      },
      saveExploreRecipeDomainsOnServer: {
        method: 'POST',
        path: '/api/v1/explore-recipes/domain-on-a-server-recipes/',
      },
      updateExploreRecipeDomainsOnServer: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/domain-on-a-server-recipes/{uuid}/',
      },
      changeScopeExploreRecipeDomainsOnServer: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/domain-on-a-server-recipes/{uuid}/change-scope/',
      },
      loadExploreRecipeSpoofing: {
        method: 'GET',
        path: '/api/v1/explore-recipes/spoofing-recipes/{uuid}/',
      },
      deleteExploreRecipeSpoofing: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/spoofing-recipes/{uuid}/',
      },
      saveExploreRecipeSpoofing: {
        method: 'POST',
        path: '/api/v1/explore-recipes/spoofing-recipes/',
      },
      updateExploreRecipeSpoofing: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/spoofing-recipes/{uuid}/',
      },
      changeScopeExploreRecipeSpoofing: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/spoofing-recipes/{uuid}/change-scope/',
      },
      loadExploreRecipeNameInTXT: {
        method: 'GET',
        path: '/api/v1/explore-recipes/name-in-txt-recipes/{uuid}/',
      },
      deleteExploreRecipeNameInTXT: {
        method: 'DELETE',
        path: '/api/v1/explore-recipes/name-in-txt-recipes/{uuid}/',
      },
      saveExploreRecipeNameInTXT: {
        method: 'POST',
        path: '/api/v1/explore-recipes/name-in-txt-recipes/',
      },
      updateExploreRecipeNameInTXT: {
        method: 'PATCH',
        path: '/api/v1/explore-recipes/name-in-txt-recipes/{uuid}/',
      },
      changeScopeExploreRecipeNameInTXT: {
        method: 'PATCH',
        path:
          '/api/v1/explore-recipes/name-in-txt-recipes/{uuid}/change-scope/',
      },
      queryNameInTXTRecipe: {
        method: 'POST',
        path: '/api/v1/explore-recipes/name-in-txt-recipes/query/',
      },
      cloneGeneralExploreRecipe: {
        method: 'POST',
        path: '/api/v1/explore-recipes/{name}/{uuid}/clone/',
      },
      mergeApiEnrichment: {
        method: 'POST',
        path:
          '/api/v1/merge-api/enrichment/?origin_uid=ENRICHMENT&is_voluntary=1',
      },
      mergeApiNewEnrichment: {
        method: 'GET',
        path:
          '/api/v1/merge-api/explore/enrich/{iocType}/{name}?explain=1&scan_data=1&with_metadata=1&origin_uid=ENRICHMENT&is_voluntary=1',
      },
      loadUtilsParseIOC: {
        method: 'POST',
        path: '/api/v2/utils/parse-ioc/',
      },
      loadDnsRecords: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadARecordsDomainEnrichment: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadAAAARecordsDomainEnrichment: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadCNAMERecordsDomainEnrichment: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadMXRecordsDomainEnrichment: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadNSRecordsDomainEnrichment: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadSOARecordsDomainEnrichment: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadTXTRecordsDomainEnrichment: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadIpDensity: {
        method: 'GET',
        path:
          '/api/v1/merge-api/explore/padns/lookup/density/{iocType}/{ip}?is_voluntary={is_voluntary}',
      },
      loadPTRLookup: {
        method: 'GET',
        path:
          '/api/v1/merge-api/explore/padns/lookup/query/{iocType}/{ip}?is_voluntary={is_voluntary}',
      },
      loadIOCSFromSpecificCollection: {
        method: 'GET',
        path: '/api/v2/iocs/sources/{uuid}/iocs-summary/',
        //path:
        // '/threat-ranking/?page=1&limit=100&source={uuid}&order=-total%2C-last_seen_on%2C-id&last_seen_from=&last_seen_to=&total_custom_min=0&total_custom_max=100&total_feed_min=0&total_feed_max=100&total_ioc_min=0&total_ioc_max=100&total_min=0&total_max=100',
      },
      loadIOCSPageFromSpecificCollection: {
        method: 'GET',
        path: '/api/v2/iocs/sources/{uuid}/iocs-summary/?page={page}',
      },
      loadIOCSFromSpecificSharedCollection: {
        method: 'GET',
        path: '/api/v2/iocs/sources/{uuid}/iocs-summary/',
      },
      loadHistoryQueries: {
        method: 'GET',
        path: '/api/v2/history-queries/history-queries/?',
      },
      loadHistoryQueryResult: {
        method: 'GET',
        path: '/api/v2/history-queries/history-queries/{uuid}/result/',
      },
      copyHistoryQueryResult: {
        method: 'GET',
        path: '/api/v2/history-queries/history-queries/{uuid}/result/',
      },
      downloadHistoryQueryResult: {
        method: 'GET',
        path: '/api/v2/history-queries/history-queries/{uuid}/download/',
      },
      loadMonitoringQueries: {
        method: 'GET',
        path: '/api/v1/monitors/monitor-queries/?',
      },
      saveMonitoringQuery: {
        method: 'POST',
        path: '/api/v1/monitors/monitor-queries/',
      },
      updateMonitoringQuery: {
        method: 'PUT',
        path: '/api/v1/monitors/monitor-queries/{uuid}/',
      },
      deleteMonitoringQuery: {
        method: 'DELETE',
        path: '/api/v1/monitors/monitor-queries/{uuid}/',
      },
      changeScopeMonitoringQuery: {
        method: 'PATCH',
        path: '/api/v1/monitors/monitor-queries/{uuid}/change-scope/',
      },
      runMonitoringQuery: {
        method: 'get',
        path: '/api/v1/monitors/monitor-queries/{uuid}/apply/',
      },
      loadMonitoringQueryResultsHistory: {
        method: 'GET',
        path: '/api/v1/monitors/monitor-queries/{uuid}/results-history/',
      },
      loadMonitoringFile: {
        method: 'GET',
        path: '/api/v1/file-storage/files/{uuid}/export/',
      },
      loadMonitoringJSONFile: {
        method: 'GET',
        path: '/api/v1/monitors/monitor-queries/{uuid}/result/',
      },
      loadMergeAPIWhoisFallbackDetails: {
        method: 'GET',
        path: '/api/v1/merge-api/explore/{path}',
      },
      loadBrandImpersonationRecipeResults: {
        method: 'GET',
        path: '/api/v1/explore-recipes/spoofing-recipes/query/{path}',
      },
      loadHostingInfrastructureASNsRecipeResults: {
        method: 'GET',
        path: '/api/v1/explore-recipes/hosting-infra-asns-recipes/query/{path}',
      },
      loadDanglingDNSDetectionRecipeResults: {
        method: 'GET',
        path:
          '/api/v1/explore-recipes/dangling-dns-record-recipes/query/{path}',
      },
      loadHostingInfrastructureIPsRecipeResults: {
        method: 'GET',
        path: '/api/v1/explore-recipes/hosting-infra-ips-recipes/query/{path}',
      },
      loadShadowITRecipeResults: {
        method: 'GET',
        path: '/api/v1/explore-recipes/shadow-it-recipes/query/{path}',
      },
      loadSubdomainFinderRecipeResults: {
        method: 'GET',
        path: '/api/v1/explore-recipes/subdomain-finder-recipes/query/{path}',
      },
    },
    Filters: {
      load: {
        method: 'GET',
        path: '/api/v1/filters/',
      },
      loadSpecific: {
        method: 'GET',
        path: '/api/v2/filters/{name}/?format={dataType}',
      },
      loadTagOptions: {
        method: 'GET',
        path: '/api/v2/filters/tag/name/?format=json',
      },
      autoCompleteTagOptions: {
        method: 'GET',
        path: '/api/v2/filters/tag/name/?format=json&query={tagName}',
      },
    },
    Tag: {
      create: {
        method: 'POST',
        path: '/api/v1/tag/',
      },
      delete: {
        method: 'DELETE',
        path: '/api/v1/tag/{id}/',
      },
    },
    Source: {
      loadSources: {
        method: 'GET',
        path: '/api/v2/iocs/sources/?',
      },
      loadSource: {
        method: 'GET',
        path: '/api/v2/iocs/sources/{uuid}/',
      },
      loadSourcesIocCountsAndIsActive: {
        method: 'GET',
        path: '/api/v2/iocs/sources/sources-iocs-counts-and-is-active/?',
      },
      loadSourcesIocCounts: {
        method: 'GET',
        path: '/api/v2/iocs/sources/auto-refresh/?',
      },
      createEmptySource: {
        method: 'POST',
        path: '/api/v2/iocs/sources/create-empty-source/',
      },
      createURLSource: {
        method: 'POST',
        path: '/api/v2/iocs/sources/create-url-source/',
      },
      createFileSource: {
        method: 'POST',
        path: '/api/v2/iocs/sources/create-file-source/',
      },
      deleteSource: {
        method: 'DELETE',
        path: '/api/v2/iocs/sources/{uuid}/',
      },
      changeSourceScope: {
        method: 'PATCH',
        path: '/api/v2/iocs/sources/{uuid}/change-scope/',
      },
      activateSource: {
        method: 'PATCH',
        path: '/api/v2/iocs/sources/{uuid}/activate/',
      },
      updateSource: {
        method: 'PATCH',
        path: '/api/v2/iocs/sources/{uuid}/',
      },
      updateFileSource: {
        method: 'PUT',
        path: '/api/v2/iocs/sources/{uuid}/update-file-source/',
      },
      addIOCJson: {
        method: 'PUT',
        path: '/api/v2/iocs/sources/{uuid}/add-ioc-json/',
      },

      publishSource: {
        method: 'PATCH',
        path: '/api/v2/iocs/sources/{uuid}/publish/',
      },
    },
    Feed: {
      create: {
        method: 'POST',
        path: '/api/v1/feeds/',
      },
      createVirtualFeed: {
        method: 'POST',
        path: '/api/v1/feeds/upload/',
      },
      update: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      updateVirtualFeed: {
        method: 'PUT',
        path: '/api/v1/feeds/upload/',
      },
      loadIPEditableFeeds: {
        method: 'GET',
        path: '/api/v2/iocs/sources/editable-sources/?type=ip&state={state}',
      },
      loadDomainEditableFeeds: {
        method: 'GET',
        path:
          '/api/v2/iocs/sources/editable-sources/?type=domain&state={state}',
      },
      loadURLEditableFeeds: {
        method: 'GET',
        path: '/api/v2/iocs/sources/editable-sources/?type=url&state={state}',
      },
      delete: {
        method: 'DELETE',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      deleteCollection: {
        method: 'DELETE',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      deleteFeed: {
        method: 'DELETE',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      deleteMyFeed: {
        method: 'DELETE',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      deleteOrganizationFeed: {
        method: 'DELETE',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      exportFeed: {
        method: 'POST',
        path:
          '/api/v2/iocs/export/full-csv/?page=1&limit=10000&source={uuid}&order=-total%2C-last_seen_on%2C-id&last_seen_from=&last_seen_to=&total_custom_min=0&total_custom_max=100&total_feed_min=0&total_feed_max=100&total_ioc_min=0&total_ioc_max=100&total_min=0&total_max=100',
        binary: true,
      },
      load: {
        method: 'GET',
        // path: '/api/v1/all-feeds/',
        path: '/api/v1/all-feeds/Temp/',
      },
      activateCollection: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/activate/',
        path: '/api/v1/all-feeds/Temp/',
      },
      activateFeed: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/activate/',
        path: '/api/v1/all-feeds/Temp/',
      },
      activateMyFeed: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/activate/',
        path: '/api/v1/all-feeds/Temp/',
      },
      activateOrganizationFeed: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/activate/',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadCollections: {
        method: 'GET',
        // path: '/api/v1/all-feeds/?state=COLLECTION',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadFeeds: {
        method: 'GET',
        // path: '/api/v1/all-feeds/?state=FEED',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadNewFeeds: {
        method: 'GET',
        // path: '/api/v1/new-all-feeds/?state=FEED',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadOrganizationCollections: {
        method: 'GET',
        // path: '/api/v1/all-feeds/?state=COLLECTION&is_shared=True',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadOrganizationFeeds: {
        method: 'GET',
        // path: '/api/v1/all-feeds/?state=FEED&is_shared=True',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadNewOrganizationFeeds: {
        method: 'GET',
        // path: '/api/v1/new-all-feeds/?state=FEED&is_shared=True',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadMyCollections: {
        method: 'GET',
        // path: '/api/v1/all-feeds/?state=COLLECTION&is_created_by_me=True',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadMyFeeds: {
        method: 'GET',
        // path: '/api/v1/all-feeds/?state=FEED&is_created_by_me=True',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadNewMyFeeds: {
        method: 'GET',
        // path: '/api/v1/new-all-feeds/?state=FEED&is_created_by_me=True',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadCollection: {
        method: 'GET',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadAllFeeds: {
        method: 'GET',
        // path: '/api/v1/all-feeds/',
        path: '/api/v1/all-feeds/Temp/',
      },
      updateCollection: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      changeScopeCollection: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/change-scope/',
        path: '/api/v1/all-feeds/Temp/',
      },
      publishCollection: {
        method: 'PATCH',
        path: '/api/v2/iocs/sources/{uuid}/publish/',
      },
      shareCollection: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/?state=COLLECTION',
        path: '/api/v1/all-feeds/Temp/',
      },
      createCollectionByFileUpload: {
        method: 'POST',
        // path: '/api/v1/all-feeds/create-from-file/',
        path: '/api/v1/all-feeds/Temp/',
      },
      createCollectionByURLUpload: {
        method: 'POST',
        // path: '/api/v1/all-feeds/create-from-url/',
        path: '/api/v1/all-feeds/Temp/',
      },
      uploadToCollection: {
        method: 'PUT',
        // path: '/api/v1/all-feeds/{uuid}/add-iocs-file/',
        path: '/api/v1/all-feeds/Temp/',
      },
      saveEmptyCollection: {
        method: 'POST',
        // path: '/api/v1/all-feeds/',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadAvailable: {
        method: 'GET',
        path: '/api/v1/user-available-feeds/',
      },
      createGlobal: {
        method: 'POST',
        // path: '/api/v1/all-feeds/create-from-url/',
        path: '/api/v1/all-feeds/Temp/',
      },
      updateGlobal: {
        method: 'PATCH',
        // path: '/api/v1/all-feeds/{uuid}/',
        path: '/api/v1/all-feeds/Temp/',
      },
      deleteGlobal: {
        method: 'DELETE',
        path: '/api/v1/generic-feed-source/{uuid}/',
      },
      loadGlobalFeeds: {
        method: 'GET',
        // path: '/api/v1/all-feeds/',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadFeedsGlobal: {
        method: 'GET',
        // path: '/api/v1/all-feeds/?is_public=true',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadNewFeedsGlobal: {
        method: 'GET',
        // path: '/api/v1/new-all-feeds/?is_public=true',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadFeedPerformance: {
        method: 'GET',
        // path: '/api/v1/all-feeds/feeds-performance/',
        path: '/api/v1/all-feeds/Temp/',
      },
      loadSourcesReports: {
        method: 'GET',
        path: 'api/v2/iterum/sources-report/?limit=1000',
      },
      loadSourceReport: {
        method: 'GET',
        path: '/api/v2/sources-report/{feed_uuid}/',
      },
      consumeFeedData: {
        method: 'POST',
        path: '/api/v2/iocs/sources/pull-data/',
      },
      verifyAuth: {
        method: 'POST',
        path: '/api/v2/iocs/sources/verify-auth/',
      },
    },
    Integrations: {
      getAccessTokenBrowserling: {
        method: 'POST',
        path: '/api/v1/validation-tools/browserling/login/',
      },
      loadSplunk: {
        method: 'GET',
        path: '/api/v1/integrations/splunk/',
      },
      updateSplunk: {
        method: 'PUT',
        path: '/api/v1/integrations/splunk/{uuid}/',
      },
      saveSplunk: {
        method: 'POST',
        path: '/api/v1/integrations/splunk/',
      },
      deleteSplunk: {
        method: 'DELETE',
        path: '/api/v1/integrations/splunk/{uuid}/',
      },
      loadSlack: {
        method: 'GET',
        path: '/api/v1/integrations/slack/',
      },
      updateSlack: {
        method: 'PUT',
        path: '/api/v1/integrations/slack/{uuid}/',
      },
      saveSlack: {
        method: 'POST',
        path: '/api/v1/integrations/slack/',
      },
      deleteSlack: {
        method: 'DELETE',
        path: '/api/v1/integrations/slack/{uuid}/',
      },
      loadMTeams: {
        method: 'GET',
        path: '/api/v1/integrations/microsoft-teams/',
      },
      updateMTeams: {
        method: 'PUT',
        path: '/api/v1/integrations/microsoft-teams/{uuid}/',
      },
      saveMTeams: {
        method: 'POST',
        path: '/api/v1/integrations/microsoft-teams/',
      },
      deleteMTeams: {
        method: 'DELETE',
        path: '/api/v1/integrations/microsoft-teams/{uuid}/',
      },
    },
    Tags: {
      search: {
        method: 'GET',
        path: '/api/v1/tag/',
      },
      create: {
        method: 'POST',
        path: '/api/v1/tag/',
      },

      addToIOC: {
        method: 'POST',
        path: '/api/v1/tag/{id}/add/',
      },
      removeFromIOC: {
        method: 'POST',
        path: '/api/v1/tag/{id}/remove/',
      },
    },
    Group: {
      list: {
        method: 'GET',
        path: '/api/v1/group/',
      },
      create: {
        method: 'POST',
        path: '/api/v1/group/',
      },
      update: {
        method: 'PATCH',
        path: '/api/v1/group/{uuid}/',
      },
      delete: {
        method: 'DELETE',
        path: '/api/v1/group/{uuid}/',
      },
    },
    Department: {
      list: {
        method: 'GET',
        path: '/api/v1/departments/',
      },
      create: {
        method: 'POST',
        path: '/api/v1/departments/',
      },
      update: {
        method: 'PATCH',
        path: '/api/v1/departments/{uuid}/',
      },
      delete: {
        method: 'DELETE',
        path: '/api/v1/departments/{uuid}/',
      },
    },
    APIAccess: {
      list: {
        method: 'GET',
        path: '/api/v1/api-access/?mine_only={mine_only}',
      },
      create: {
        method: 'POST',
        path: '/api/v1/api-access/',
      },
      update: {
        method: 'PATCH',
        path: '/api/v1/api-access/{uuid}/',
      },
      delete: {
        method: 'DELETE',
        path: '/api/v1/api-access/{uuid}/',
      },
    },
    Permission: {
      list: {
        method: 'GET',
        path: '/api/v1/permissions/',
      },
      request: {
        method: 'POST',
        path: '/api/v1/permission-requests/',
      },
    },
    Widget: {
      mostWidespreadTag: {
        method: 'GET',
        path: '/api/v1/widgets/most-widespread-tag/',
      },
      topTrendingTags: {
        method: 'GET',
        path: '/api/v1/widgets/top-trending-tags/',
      },
      fpAvg: {
        method: 'GET',
        path: '/api/v1/widgets/fp-avg-total/',
      },
    },
    Dashboard: {
      list: {
        method: 'GET',
        path: '/api/v1/available_dashboards/',
      },
      create: {
        method: 'POST',
        path: '/api/v1/user_dashboards/',
      },
      details: {
        method: 'GET',
        path: '/api/v1/user_dashboards/{uuid}/',
      },
      loadWidgets: {
        method: 'GET',
        path: '/api/v1/dashboard_widgets/',
      },
      updateCell: {
        method: 'PUT',
        path: '/api/v1/dashboard_cell/{uuid}/',
      },
    },
    Playbooks: {
      loadPlaybooks: {
        method: 'GET',
        path: '/api/v1/playbook/',
      },
      loadPlaybooksLogs: {
        method: 'GET',
        path: '/api/v1/playbook-log/',
      },
      updatePlaybooks: {
        method: 'PUT',
        path: '/api/v1/playbook/{uuid}/',
      },
      savePlaybooks: {
        method: 'POST',
        path: '/api/v1/playbook/',
      },
      deletePlaybooks: {
        method: 'DELETE',
        path: '/api/v1/playbook/{uuid}/',
      },
      runPlaybooks: {
        method: 'GET',
        path: '/api/v1/playbook/{uuid}/run/',
      },
    },
    Staff: {
      loadCustomerOrganizationList: {
        method: 'GET',
        path: '/api/v2/staff/organisations/',
      },
      loadCustomerOrganizationListPage: {
        method: 'GET',
        path:
          '/api/v2/staff/organisations/?page={page}&searchText={searchText}',
      },
      updateCustomerOrganization: {
        method: 'PATCH',
        path: '/api/v2/staff/organisations/{uuid}/',
      },
      loadCustomerSubscriptionPlan: {
        method: 'GET',
        path: '/api/v2/staff/subscription-plans/{uuid}/',
      },
      createCustomerSubscription: {
        method: 'POST',
        path: '/api/v2/staff/subscriptions/',
      },
      updateCustomerSubscription: {
        method: 'PATCH',
        path: '/api/v2/staff/subscriptions/{uuid}/',
      },
      restrictSubscriptionCustomerOrganization: {
        method: 'GET',
        path: '/api/v2/staff/subscriptions/{uuid}/restrict/',
      },
      unrestrictSubscriptionCustomerOrganization: {
        method: 'GET',
        path: '/api/v2/staff/subscriptions/{uuid}/unrestrict/',
      },
      notifySubscriptionRestrictedCustomerOrganization: {
        method: 'GET',
        path:
          '/api/v1/staff/organisations/{id}/notify-subscription-restricted/',
      },
      createCustomerOrganization: {
        method: 'POST',
        path: '/api/v2/staff/organisations/',
      },
      loadCustomerOrganization: {
        method: 'GET',
        path: '/api/v2/staff/organisations/{uuid}/',
      },
      deleteCustomerOrganization: {
        method: 'DELETE',
        path: '/api/v2/staff/organisations/{uuid}/',
      },
      loadCustomerOrganizationUsersList: {
        method: 'GET',
        path: '/api/v1/staff/organisations/{id}/users/',
      },
      loadCustomerOrganizationUsersListPage: {
        method: 'GET',
        path: '/api/v1/staff/organisations/{id}/users/?page={page}',
      },
      updateCustomerOrganizationUser: {
        method: 'PUT',
        path: '/api/v1/staff/organisations/{id}/users/{uuid}/',
      },
      createCustomerOrganizationUser: {
        method: 'POST',
        path: '/api/v1/staff/organisations/{id}/users/',
      },
      deleteCustomerOrganizationUser: {
        method: 'DELETE',
        path: '/api/v1/staff/organisations/{id}/users/{uuid}/',
      },
      inviteCustomerOrganizationUser: {
        method: 'GET',
        path: '/api/v1/staff/organisations/{id}/users/{uuid}/invite/',
      },
      addFPsCustomerOrganizationUser: {
        // add missing pre-defined filter profiles
        method: 'GET',
        path:
          '/api/v1/staff/organisations/{id}/users/{uuid}/add-predefined-filter-profiles/',
      },
      loadUsersInfoForStaffMember: {
        method: 'GET',
        path: 'api/v2/staff/users/users-info/?text={text}',
      },
      transferUserFormOrgToAnother: {
        method: 'POST',
        path: 'api/v2/staff/users/{uuid}/transfer/',
      },
      notifySubscriptionExpiredCustomerOrganizationUser: {
        method: 'GET',
        path: '/api/v1/staff/ui-demo-users/{id}/notify-subscription-expired/',
      },
      setOrganizationActive: {
        method: 'PATCH',
        path: '/api/v2/staff/organisations/{uuid}/activate/',
      },
      setOrganizationInactive: {
        method: 'PATCH',
        path: '/api/v2/staff/organisations/{uuid}/deactivate/',
      },
    },
    Download: {
      fileDownload: {
        method: 'GET',
        path: '/api/v1/file-storage/files/{fileUUID}/download/',
        binary: true,
      },
      fileContentCopy: {
        method: 'GET',
        path: '/api/v1/file-storage/files/{fileUUID}/monitor-result/',
      },
      loadResultFile: {
        method: 'GET',
        path: '/api/v1/file-storage/files/{fileUUID}/monitor-result/',
      },
    },
    Bulkdata: {
      loadBulkDataFeeds: {
        method: 'GET',
        path: '/api/v2/bulk-data-feeds/{filterParams}',
      },
      loadBulkDataFeedOptions: {
        method: 'GET',
        path: '/api/v2/bulk-data-feeds/feeds-list/',
      },
      downloadBulkDataFeed: {
        method: 'GET',
        path: '/api/v2/generate/bulk-feeds/{filename}/',
      },
    },
    Marketplace: {
      loadDataMarketplaceCategories: {
        method: 'GET',
        path: '/api/v2/data-marketplace/categories/',
      },
      loadDataMarketplaceFeeds: {
        method: 'GET',
        path: '/api/v2/data-marketplace/categories/{categorySlug}/feeds/?',
      },
      loadDataMarketplaceFeedOptions: {
        method: 'GET',
        path: '/api/v2/data-marketplace/feeds-list/',
      },
      downloadDataMarketplaceFeed: {
        method: 'GET',
        path: '/api/v2/generate/{categorySlug}/{filename}/',
      },
    },
    Blog: {
      loadAmberReports: {
        method: 'GET',
        path: '/api/v2/tlp-amber-reports/blogs/?page={currentPage}',
      },
      loadAmberReport: {
        method: 'GET',
        path: '/api/v2/tlp-amber-reports/blogs/{uuid}/',
      },
      loadAmberReportCount: {
        method: 'GET',
        path: '/api/v2/tlp-amber-reports/blogs/unseen/',
      },
      loadAmberReportFeeds: {
        method: 'GET',
        path: '/api/v2/tlp-amber-reports/blogs/feeds/',
      },
      loadAmberReportTags: {
        method: 'GET',
        path: '/api/v2/tlp-amber-reports/blog-tags/',
      },
      filterAmberReports: {
        method: 'GET',
        path: '/api/v2/tlp-amber-reports/blogs/{filterParams}',
      },
      setAmberReportsAsSeen: {
        method: 'POST',
        path: '/api/v2/tlp-amber-reports/blogs/mark-seen/',
      },
      setAmberReportUnseen: {
        method: 'POST',
        path: '/api/v2/tlp-amber-reports/blogs/mark-seen/',
      },
      checkEnrichmentFeedHasBlogs: {
        method: 'GET',
        path: '/api/v2/tlp-amber-reports/feed-has-blogs/?feeds={uuids}',
      },
    },
  },
};

export default Manifest;
